@if(shouldShow()) {
   <button class="t-go-back cursor-pointer font-bold" (click)="goBack()"  *transloco="let t"> {{ t('pages.backlink') }}</button>
}